import { TbTransfer } from "react-icons/tb";
export const AdminNavLinks = [
  {
    tab: "Dashboard",
    activeurl: "dashboard",
    url: "/dashboard",
    tabAccessKey: "Dashboard",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M14.0755 0H17.4615C18.8637 0 20 1.14585 20 2.55996V5.97452C20 7.38864 18.8637 8.53449 17.4615 8.53449H14.0755C12.6732 8.53449 11.537 7.38864 11.537 5.97452V2.55996C11.537 1.14585 12.6732 0 14.0755 0Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.53852 0H5.92449C7.32676 0 8.46301 1.14585 8.46301 2.55996V5.97452C8.46301 7.38864 7.32676 8.53449 5.92449 8.53449H2.53852C1.13626 8.53449 0 7.38864 0 5.97452V2.55996C0 1.14585 1.13626 0 2.53852 0ZM2.53852 11.4655H5.92449C7.32676 11.4655 8.46301 12.6114 8.46301 14.0255V17.44C8.46301 18.8532 7.32676 20 5.92449 20H2.53852C1.13626 20 0 18.8532 0 17.44V14.0255C0 12.6114 1.13626 11.4655 2.53852 11.4655ZM17.4615 11.4655H14.0755C12.6732 11.4655 11.537 12.6114 11.537 14.0255V17.44C11.537 18.8532 12.6732 20 14.0755 20H17.4615C18.8637 20 20 18.8532 20 17.44V14.0255C20 12.6114 18.8637 11.4655 17.4615 11.4655Z"
        />
      </svg>
    ),
  },
  {
    tab: "Zone & Ward",
    activeurl: "zone-ward",
    url: "/zone-ward",
    tabAccessKey: "Zone_Ward",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M12.0865 22C11.9627 22 11.8388 21.9716 11.7271 21.9137L8.12599 20.0496C7.10415 19.5201 6.30481 18.9259 5.68063 18.2336C4.31449 16.7195 3.5544 14.776 3.54232 12.7599L3.50004 6.12426C3.495 5.35842 3.98931 4.67103 4.72826 4.41215L11.3405 2.10679C11.7331 1.96656 12.1711 1.9646 12.5707 2.09992L19.2081 4.32684C19.9511 4.57493 20.4535 5.25742 20.4575 6.02228L20.4998 12.6628C20.5129 14.676 19.779 16.6274 18.434 18.1581C17.8168 18.8602 17.0245 19.4632 16.0128 20.0025L12.4439 21.9088C12.3331 21.9686 12.2103 21.999 12.0865 22Z"
        />
        <path d="M11.3191 14.3209C11.1258 14.3219 10.9325 14.2523 10.7835 14.1091L8.86671 12.2656C8.57073 11.9793 8.56771 11.5145 8.86067 11.2262C9.15363 10.9369 9.63183 10.934 9.92882 11.2193L11.308 12.5451L14.6756 9.22479C14.9695 8.93552 15.4477 8.93258 15.7437 9.21793C16.0407 9.50426 16.0437 9.97004 15.7508 10.2574L11.8517 14.1022C11.7047 14.2474 11.5124 14.3199 11.3191 14.3209Z" />
      </svg>
    ),
  },
  {
    tab: "Garbage Info",
    activeurl: "garbage-info",
    url: "/garbage-info",
    tabAccessKey: "Garbage_Info",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M11.9912 18.6217L5.49945 21.8643C5.00921 22.1304 4.39768 21.9527 4.12348 21.4645C4.0434 21.311 4.00106 21.1404 4 20.967V13.709C4 14.4286 4.40573 14.8728 5.47299 15.3702L11.9912 18.6217Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.89526 2H15.0695C17.7773 2 19.9735 3.06605 20 5.79337V20.9668C19.9989 21.1374 19.9565 21.3051 19.8765 21.4554C19.7479 21.7007 19.5259 21.8827 19.2615 21.9598C18.997 22.0368 18.7128 22.0023 18.4741 21.8641L11.9912 18.6215L5.47299 15.3701C4.40573 14.8726 4 14.4284 4 13.7088V5.79337C4 3.06605 6.19625 2 8.89526 2ZM8.22492 9.62227H15.7486C16.1822 9.62227 16.5336 9.26828 16.5336 8.83162C16.5336 8.39495 16.1822 8.04096 15.7486 8.04096H8.22492C7.79137 8.04096 7.43991 8.39495 7.43991 8.83162C7.43991 9.26828 7.79137 9.62227 8.22492 9.62227Z"
        />
      </svg>
    ),
  },
  {
    tab: "User Garbage Entry",
    activeurl: "user-garbage",
    url: "/user-garbage",
    tabAccessKey: "User Garbage Entry",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.0004 12.6039C22.0004 14.5818 21.4139 16.5153 20.315 18.1599C19.2162 19.8044 17.6543 21.0862 15.827 21.8431C13.9997 22.6 11.9889 22.7981 10.049 22.4122C8.10912 22.0263 6.32722 21.0739 4.92863 19.6753C3.53005 18.2767 2.5776 16.4948 2.19173 14.5549C1.80586 12.615 2.00391 10.6043 2.76081 8.77694C3.51772 6.9496 4.7995 5.38775 6.44406 4.28889C8.08862 3.19003 10.0221 2.60352 12 2.60352C13.3133 2.60352 14.6137 2.86218 15.827 3.36475C17.0403 3.86732 18.1427 4.60395 19.0714 5.53257C20 6.4612 20.7366 7.56363 21.2392 8.77694C21.7418 9.99025 22.0004 11.2907 22.0004 12.6039ZM17.9116 9.10246C17.9109 8.83756 17.8055 8.58367 17.6183 8.39624C17.4311 8.20881 17.1773 8.10304 16.9124 8.10204H7.14189C6.87699 8.10304 6.62324 8.20881 6.43604 8.39624C6.24884 8.58367 6.1434 8.83756 6.14274 9.10246V15.6545C6.14373 15.9191 6.24932 16.1727 6.43648 16.3599C6.62365 16.547 6.87721 16.6526 7.14189 16.6536H10.8429L11.7954 18.1833C11.813 18.2248 11.8425 18.2602 11.8801 18.2851C11.9177 18.31 11.9618 18.3233 12.0069 18.3233C12.0521 18.3233 12.0962 18.31 12.1338 18.2851C12.1714 18.2602 12.2009 18.2248 12.2185 18.1833L13.1722 16.6549H16.9112C17.1761 16.6539 17.4298 16.5481 17.617 16.3607C17.8042 16.1733 17.9096 15.9194 17.9103 15.6545L17.9116 9.10246ZM12.6632 14.5201C12.6632 14.6458 12.6259 14.7687 12.5561 14.8731C12.4863 14.9776 12.387 15.0591 12.2709 15.1072C12.1548 15.1552 12.0271 15.1678 11.9038 15.1433C11.7806 15.1188 11.6674 15.0583 11.5785 14.9694C11.4897 14.8806 11.4291 14.7674 11.4046 14.6441C11.3801 14.5209 11.3927 14.3931 11.4408 14.277C11.4889 14.1609 11.5703 14.0617 11.6748 13.9919C11.7793 13.922 11.9021 13.8848 12.0278 13.8848C12.1963 13.8848 12.3579 13.9517 12.4771 14.0709C12.5962 14.19 12.6632 14.3516 12.6632 14.5201ZM11.5263 12.9058V9.99173C11.5263 9.85889 11.5791 9.7315 11.673 9.63758C11.7669 9.54365 11.8943 9.49088 12.0272 9.49088C12.16 9.49088 12.2874 9.54365 12.3813 9.63758C12.4752 9.7315 12.528 9.85889 12.528 9.99173V12.9058C12.528 13.0385 12.4753 13.1657 12.3815 13.2595C12.2877 13.3533 12.1605 13.406 12.0278 13.406C11.8951 13.406 11.7679 13.3533 11.6741 13.2595C11.5803 13.1657 11.5276 13.0385 11.5276 12.9058H11.5263Z" />
      </svg>
    ),
  },
  {
    tab: "Manage Departments",
    activeurl: "manage-departments",
    url: "/manage-departments",
    tabAccessKey: "Manage_Departments",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M10.0833 15.958H3.50777C2.67555 15.958 2 16.6217 2 17.4393C2 18.2559 2.67555 18.9207 3.50777 18.9207H10.0833C10.9155 18.9207 11.5911 18.2559 11.5911 17.4393C11.5911 16.6217 10.9155 15.958 10.0833 15.958Z"
        />
        <path
          opacity="0.4"
          d="M22 6.37867C22 5.56214 21.3244 4.89844 20.4933 4.89844H13.9178C13.0856 4.89844 12.41 5.56214 12.41 6.37867C12.41 7.1963 13.0856 7.86 13.9178 7.86H20.4933C21.3244 7.86 22 7.1963 22 6.37867Z"
        />
        <path d="M8.87774 6.37856C8.87774 8.24523 7.33886 9.75821 5.43887 9.75821C3.53999 9.75821 2 8.24523 2 6.37856C2 4.51298 3.53999 3 5.43887 3C7.33886 3 8.87774 4.51298 8.87774 6.37856Z" />
        <path d="M22.0001 17.3992C22.0001 19.2648 20.4612 20.7777 18.5612 20.7777C16.6623 20.7777 15.1223 19.2648 15.1223 17.3992C15.1223 15.5325 16.6623 14.0195 18.5612 14.0195C20.4612 14.0195 22.0001 15.5325 22.0001 17.3992Z" />
      </svg>
    ),
  },
  {
    tab: "User Management",
    activeurl: "user-management",
    url: "/user-management",
    tabAccessKey: "User_Management",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.9491 14.54C8.49909 14.54 5.58813 15.1038 5.58813 17.2795C5.58813 19.4562 8.51789 20.0001 11.9491 20.0001C15.3991 20.0001 18.31 19.4364 18.31 17.2606C18.31 15.084 15.3803 14.54 11.9491 14.54Z" />
        <path
          opacity="0.4"
          d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z"
        />
        <path
          opacity="0.4"
          d="M21.0879 9.21923C21.6923 6.84176 19.9203 4.70654 17.6639 4.70654C17.4186 4.70654 17.184 4.73356 16.9548 4.77949C16.9243 4.78669 16.8903 4.802 16.8724 4.82902C16.8518 4.86324 16.867 4.90917 16.8894 4.93889C17.5672 5.89528 17.9567 7.0597 17.9567 8.30967C17.9567 9.50741 17.5995 10.6241 16.9727 11.5508C16.9082 11.6462 16.9655 11.775 17.0792 11.7948C17.2368 11.8227 17.398 11.8371 17.5627 11.8416C19.2058 11.8849 20.6805 10.8213 21.0879 9.21923Z"
        />
        <path d="M22.8093 14.817C22.5084 14.1722 21.7823 13.73 20.6782 13.513C20.1571 13.3851 18.7468 13.205 17.4351 13.2293C17.4154 13.232 17.4046 13.2455 17.4028 13.2545C17.4002 13.2671 17.4055 13.2887 17.4315 13.3022C18.0377 13.6039 20.381 14.916 20.0864 17.6834C20.0738 17.8032 20.1696 17.9068 20.2887 17.8888C20.8654 17.8059 22.349 17.4853 22.8093 16.4866C23.0636 15.9589 23.0636 15.3456 22.8093 14.817Z" />
        <path
          opacity="0.4"
          d="M7.04483 4.77998C6.8165 4.73315 6.58101 4.70703 6.33567 4.70703C4.07926 4.70703 2.30726 6.84225 2.91255 9.21972C3.31906 10.8218 4.79379 11.8854 6.43685 11.8421C6.60161 11.8376 6.76368 11.8223 6.92037 11.7953C7.03409 11.7755 7.09139 11.6467 7.02692 11.5513C6.40014 10.6237 6.04288 9.5079 6.04288 8.31016C6.04288 7.05928 6.43327 5.89486 7.11109 4.93937C7.13258 4.90966 7.1487 4.86373 7.12721 4.82951C7.1093 4.80159 7.07617 4.78718 7.04483 4.77998Z"
        />
        <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" />
      </svg>
    ),
  },
  {
    tab: "Roll Access",
    activeurl: "user-roll-access",
    url: "/user-roll-access",
    tabAccessKey: "Role_Access",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M13.3051 5.88243V6.06547C12.8144 6.05584 12.3237 6.05584 11.8331 6.05584V5.89206C11.8331 5.22733 11.2737 4.68784 10.6064 4.68784H9.63482C8.52589 4.68784 7.62305 3.80152 7.62305 2.72254C7.62305 2.32755 7.95671 2 8.35906 2C8.77123 2 9.09508 2.32755 9.09508 2.72254C9.09508 3.01155 9.34042 3.24276 9.63482 3.24276H10.6064C12.0882 3.2524 13.2953 4.43736 13.3051 5.88243Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.164 6.08279C15.4791 6.08712 15.7949 6.09145 16.1119 6.09469C19.5172 6.09469 22 8.52241 22 11.875V16.1813C22 19.5339 19.5172 21.9616 16.1119 21.9616C14.7478 21.9905 13.3837 22.0001 12.0098 22.0001C10.6359 22.0001 9.25221 21.9905 7.88813 21.9616C4.48283 21.9616 2 19.5339 2 16.1813V11.875C2 8.52241 4.48283 6.09469 7.89794 6.09469C9.18351 6.07542 10.4985 6.05615 11.8332 6.05615C12.3238 6.05615 12.8145 6.05615 13.3052 6.06579C13.9238 6.06579 14.5425 6.07427 15.164 6.08279ZM10.8518 14.7459H9.82139V15.767C9.82139 16.162 9.48773 16.4896 9.08538 16.4896C8.67321 16.4896 8.34936 16.162 8.34936 15.767V14.7459H7.30913C6.90677 14.7459 6.57311 14.4279 6.57311 14.0233C6.57311 13.6283 6.90677 13.3008 7.30913 13.3008H8.34936V12.2892C8.34936 11.8942 8.67321 11.5667 9.08538 11.5667C9.48773 11.5667 9.82139 11.8942 9.82139 12.2892V13.3008H10.8518C11.2542 13.3008 11.5878 13.6283 11.5878 14.0233C11.5878 14.4279 11.2542 14.7459 10.8518 14.7459ZM15.0226 13.1177H15.1207C15.5231 13.1177 15.8567 12.7998 15.8567 12.3952C15.8567 12.0002 15.5231 11.6727 15.1207 11.6727H15.0226C14.6104 11.6727 14.2866 12.0002 14.2866 12.3952C14.2866 12.7998 14.6104 13.1177 15.0226 13.1177ZM16.7007 16.4318H16.7988C17.2012 16.4318 17.5348 16.1139 17.5348 15.7092C17.5348 15.3143 17.2012 14.9867 16.7988 14.9867H16.7007C16.2885 14.9867 15.9647 15.3143 15.9647 15.7092C15.9647 16.1139 16.2885 16.4318 16.7007 16.4318Z"
        />
      </svg>
    ),
  },
  {
    tab: "Garbage Collection",
    activeurl: "garbage-collection",
    url: "/garbage-collection",
    tabAccessKey: "Garbage_Collection",
    items: [
      {
        tab: "Residential",
        activeurl: "residential-garbage-collection",
        url: "/garbage-collection/residential-garbage-collection",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.4"
              d="M21.25 13.4764C20.429 13.4764 19.761 12.8145 19.761 12.001C19.761 11.1865 20.429 10.5246 21.25 10.5246C21.449 10.5246 21.64 10.4463 21.78 10.3076C21.921 10.1679 22 9.97864 22 9.78146L21.999 7.10415C21.999 4.84102 20.14 3 17.856 3H6.144C3.86 3 2.001 4.84102 2.001 7.10415L2 9.86766C2 10.0648 2.079 10.2541 2.22 10.3938C2.36 10.5325 2.551 10.6108 2.75 10.6108C3.599 10.6108 4.239 11.2083 4.239 12.001C4.239 12.8145 3.571 13.4764 2.75 13.4764C2.336 13.4764 2 13.8093 2 14.2195V16.8949C2 19.158 3.858 21 6.143 21H17.857C20.142 21 22 19.158 22 16.8949V14.2195C22 13.8093 21.664 13.4764 21.25 13.4764Z"
            />
            <path d="M15.4305 11.5887L14.2515 12.7367L14.5305 14.3597C14.5785 14.6407 14.4655 14.9177 14.2345 15.0837C14.0055 15.2517 13.7065 15.2727 13.4545 15.1387L11.9995 14.3737L10.5415 15.1397C10.4335 15.1967 10.3155 15.2267 10.1985 15.2267C10.0455 15.2267 9.89446 15.1787 9.76446 15.0847C9.53446 14.9177 9.42146 14.6407 9.46946 14.3597L9.74746 12.7367L8.56846 11.5887C8.36446 11.3907 8.29346 11.0997 8.38146 10.8287C8.47046 10.5587 8.70046 10.3667 8.98146 10.3267L10.6075 10.0897L11.3365 8.61268C11.4635 8.35868 11.7175 8.20068 11.9995 8.20068H12.0015C12.2845 8.20168 12.5385 8.35968 12.6635 8.61368L13.3925 10.0897L15.0215 10.3277C15.2995 10.3667 15.5295 10.5587 15.6175 10.8287C15.7065 11.0997 15.6355 11.3907 15.4305 11.5887Z" />
          </svg>
        ),
      },
      {
        tab: "Commercial",
        activeurl: "commercial-garbage-collection",
        url: "/garbage-collection/commercial-garbage-collection",
        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.4"
              d="M14.0755 0H17.4615C18.8637 0 20 1.14585 20 2.55996V5.97452C20 7.38864 18.8637 8.53449 17.4615 8.53449H14.0755C12.6732 8.53449 11.537 7.38864 11.537 5.97452V2.55996C11.537 1.14585 12.6732 0 14.0755 0Z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.53852 0H5.92449C7.32676 0 8.46301 1.14585 8.46301 2.55996V5.97452C8.46301 7.38864 7.32676 8.53449 5.92449 8.53449H2.53852C1.13626 8.53449 0 7.38864 0 5.97452V2.55996C0 1.14585 1.13626 0 2.53852 0ZM2.53852 11.4655H5.92449C7.32676 11.4655 8.46301 12.6114 8.46301 14.0255V17.44C8.46301 18.8532 7.32676 20 5.92449 20H2.53852C1.13626 20 0 18.8532 0 17.44V14.0255C0 12.6114 1.13626 11.4655 2.53852 11.4655ZM17.4615 11.4655H14.0755C12.6732 11.4655 11.537 12.6114 11.537 14.0255V17.44C11.537 18.8532 12.6732 20 14.0755 20H17.4615C18.8637 20 20 18.8532 20 17.44V14.0255C20 12.6114 18.8637 11.4655 17.4615 11.4655Z"
            />
          </svg>
        ),
      },
    ],
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M21.25 13.4764C20.429 13.4764 19.761 12.8145 19.761 12.001C19.761 11.1865 20.429 10.5246 21.25 10.5246C21.449 10.5246 21.64 10.4463 21.78 10.3076C21.921 10.1679 22 9.97864 22 9.78146L21.999 7.10415C21.999 4.84102 20.14 3 17.856 3H6.144C3.86 3 2.001 4.84102 2.001 7.10415L2 9.86766C2 10.0648 2.079 10.2541 2.22 10.3938C2.36 10.5325 2.551 10.6108 2.75 10.6108C3.599 10.6108 4.239 11.2083 4.239 12.001C4.239 12.8145 3.571 13.4764 2.75 13.4764C2.336 13.4764 2 13.8093 2 14.2195V16.8949C2 19.158 3.858 21 6.143 21H17.857C20.142 21 22 19.158 22 16.8949V14.2195C22 13.8093 21.664 13.4764 21.25 13.4764Z"
        />
        <path d="M15.4305 11.5887L14.2515 12.7367L14.5305 14.3597C14.5785 14.6407 14.4655 14.9177 14.2345 15.0837C14.0055 15.2517 13.7065 15.2727 13.4545 15.1387L11.9995 14.3737L10.5415 15.1397C10.4335 15.1967 10.3155 15.2267 10.1985 15.2267C10.0455 15.2267 9.89446 15.1787 9.76446 15.0847C9.53446 14.9177 9.42146 14.6407 9.46946 14.3597L9.74746 12.7367L8.56846 11.5887C8.36446 11.3907 8.29346 11.0997 8.38146 10.8287C8.47046 10.5587 8.70046 10.3667 8.98146 10.3267L10.6075 10.0897L11.3365 8.61268C11.4635 8.35868 11.7175 8.20068 11.9995 8.20068H12.0015C12.2845 8.20168 12.5385 8.35968 12.6635 8.61368L13.3925 10.0897L15.0215 10.3277C15.2995 10.3667 15.5295 10.5587 15.6175 10.8287C15.7065 11.0997 15.6355 11.3907 15.4305 11.5887Z" />
      </svg>
    ),
  },
  {
    tab: "Live Tracking",
    activeurl: "live-tracking",
    url: "/live-tracking",
    tabAccessKey: "Live_Tracking",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.5C12.5523 3.5 13 3.94772 13 4.5V5.57089C16.0657 6.0094 18.4906 8.43431 18.9291 11.5H20C20.5523 11.5 21 11.9477 21 12.5C21 13.0523 20.5523 13.5 20 13.5H18.9291C18.4906 16.5657 16.0657 18.9906 13 19.4291V20.5C13 21.0523 12.5523 21.5 12 21.5C11.4477 21.5 11 21.0523 11 20.5V19.4291C7.93431 18.9906 5.5094 16.5657 5.07089 13.5H4C3.44772 13.5 3 13.0523 3 12.5C3 11.9477 3.44772 11.5 4 11.5H5.07089C5.5094 8.43431 7.93431 6.0094 11 5.57089V4.5C11 3.94772 11.4477 3.5 12 3.5ZM7 12.5C7 9.73858 9.23858 7.5 12 7.5C14.7614 7.5 17 9.73858 17 12.5C17 15.2614 14.7614 17.5 12 17.5C9.23858 17.5 7 15.2614 7 12.5Z"
        />
      </svg>
    ),
  },
  {
    tab: "Grievance",
    activeurl: "grievance",
    url: "/grievance",
    tabAccessKey: "Grievance",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.0004 12.6039C22.0004 14.5818 21.4139 16.5153 20.315 18.1599C19.2162 19.8044 17.6543 21.0862 15.827 21.8431C13.9997 22.6 11.9889 22.7981 10.049 22.4122C8.10912 22.0263 6.32722 21.0739 4.92863 19.6753C3.53005 18.2767 2.5776 16.4948 2.19173 14.5549C1.80586 12.615 2.00391 10.6043 2.76081 8.77694C3.51772 6.9496 4.7995 5.38775 6.44406 4.28889C8.08862 3.19003 10.0221 2.60352 12 2.60352C13.3133 2.60352 14.6137 2.86218 15.827 3.36475C17.0403 3.86732 18.1427 4.60395 19.0714 5.53257C20 6.4612 20.7366 7.56363 21.2392 8.77694C21.7418 9.99025 22.0004 11.2907 22.0004 12.6039ZM17.9116 9.10246C17.9109 8.83756 17.8055 8.58367 17.6183 8.39624C17.4311 8.20881 17.1773 8.10304 16.9124 8.10204H7.14189C6.87699 8.10304 6.62324 8.20881 6.43604 8.39624C6.24884 8.58367 6.1434 8.83756 6.14274 9.10246V15.6545C6.14373 15.9191 6.24932 16.1727 6.43648 16.3599C6.62365 16.547 6.87721 16.6526 7.14189 16.6536H10.8429L11.7954 18.1833C11.813 18.2248 11.8425 18.2602 11.8801 18.2851C11.9177 18.31 11.9618 18.3233 12.0069 18.3233C12.0521 18.3233 12.0962 18.31 12.1338 18.2851C12.1714 18.2602 12.2009 18.2248 12.2185 18.1833L13.1722 16.6549H16.9112C17.1761 16.6539 17.4298 16.5481 17.617 16.3607C17.8042 16.1733 17.9096 15.9194 17.9103 15.6545L17.9116 9.10246ZM12.6632 14.5201C12.6632 14.6458 12.6259 14.7687 12.5561 14.8731C12.4863 14.9776 12.387 15.0591 12.2709 15.1072C12.1548 15.1552 12.0271 15.1678 11.9038 15.1433C11.7806 15.1188 11.6674 15.0583 11.5785 14.9694C11.4897 14.8806 11.4291 14.7674 11.4046 14.6441C11.3801 14.5209 11.3927 14.3931 11.4408 14.277C11.4889 14.1609 11.5703 14.0617 11.6748 13.9919C11.7793 13.922 11.9021 13.8848 12.0278 13.8848C12.1963 13.8848 12.3579 13.9517 12.4771 14.0709C12.5962 14.19 12.6632 14.3516 12.6632 14.5201ZM11.5263 12.9058V9.99173C11.5263 9.85889 11.5791 9.7315 11.673 9.63758C11.7669 9.54365 11.8943 9.49088 12.0272 9.49088C12.16 9.49088 12.2874 9.54365 12.3813 9.63758C12.4752 9.7315 12.528 9.85889 12.528 9.99173V12.9058C12.528 13.0385 12.4753 13.1657 12.3815 13.2595C12.2877 13.3533 12.1605 13.406 12.0278 13.406C11.8951 13.406 11.7679 13.3533 11.6741 13.2595C11.5803 13.1657 11.5276 13.0385 11.5276 12.9058H11.5263Z" />
      </svg>
    ),
  },
  {
    tab: "Survey Detail",
    activeurl: "survey-detail",
    url: "/survey-detail",
    tabAccessKey: "Survey_Detail",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1340_1445)">
          <path d="M21.0886 4.6228C20.9121 4.20533 20.6184 3.85227 20.2486 3.60181C19.8787 3.35206 19.4282 3.20483 18.9492 3.20483H16.9497V2.85988H14.0515C14.0647 2.76613 14.0721 2.66942 14.0721 2.57202C14.072 1.42944 13.1426 0.5 12 0.5C10.8574 0.5 9.92799 1.42944 9.92799 2.57202C9.92799 2.66942 9.9353 2.76613 9.94852 2.85988H7.05033V3.20483H5.05079C4.73143 3.20483 4.42458 3.27003 4.14699 3.38792C3.72952 3.56445 3.37576 3.85812 3.12526 4.22802C2.87551 4.59861 2.72827 5.04833 2.72827 5.52734V22.1782C2.72827 22.4961 2.79347 22.8037 2.91137 23.082C3.0879 23.4995 3.38157 23.8526 3.75146 24.103C4.12205 24.3535 4.57177 24.5 5.05079 24.5H18.9492C19.2678 24.5 19.5754 24.4355 19.853 24.3169C20.2712 24.1411 20.6243 23.8467 20.8748 23.4768C21.1245 23.1069 21.2717 22.6565 21.2717 22.1782V5.52734C21.2717 5.20803 21.2073 4.90114 21.0886 4.6228ZM12 1.80298C12.4241 1.80298 12.769 2.14794 12.769 2.57202C12.769 2.67383 12.7485 2.77048 12.7126 2.85988H11.2881C11.2515 2.77053 11.2309 2.67383 11.2309 2.57202C11.231 2.14794 11.5767 1.80298 12 1.80298ZM19.8904 22.1782C19.8904 22.3101 19.864 22.4316 19.8164 22.5437C19.7461 22.7114 19.626 22.8565 19.4751 22.959C19.3242 23.06 19.147 23.1186 18.9492 23.1186H5.05079C4.91893 23.1186 4.79663 23.0922 4.68455 23.0454C4.51608 22.9743 4.3718 22.8535 4.26999 22.7033C4.16893 22.5524 4.11033 22.3752 4.10958 22.1782V5.52734C4.10958 5.39548 4.13597 5.27319 4.18355 5.16111C4.25462 4.99264 4.37471 4.84761 4.52485 4.74655C4.67574 4.64548 4.85297 4.58689 5.05074 4.58614H7.05024V4.874C7.05024 5.41452 7.48824 5.85252 8.02951 5.85252H15.9712C16.5117 5.85252 16.9497 5.41452 16.9497 4.874V4.58614H18.9492C19.081 4.58614 19.2033 4.61253 19.3154 4.66011C19.4831 4.73042 19.6282 4.85056 19.73 5.00141C19.8318 5.15225 19.8904 5.32953 19.8904 5.5273V22.1782Z" />
          <path d="M8.80154 8.5H7.31912V9.98242H8.80154V8.5Z" />
          <path d="M16.6817 8.5H10.5711V9.98242H16.6817V8.5Z" />
          <path d="M8.80154 12.8809H7.31912V14.3633H8.80154V12.8809Z" />
          <path d="M16.6817 12.8809H10.5711V14.3633H16.6817V12.8809Z" />
          <path d="M8.80154 17.2617H7.31912V18.7441H8.80154V17.2617Z" />
          <path d="M16.6817 17.2617H10.5711V18.7441H16.6817V17.2617Z" />
        </g>
        <defs>
          <clipPath id="clip0_1340_1445">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    tab: "Dump Yard",
    activeurl: "dump-yard",
    url: "/dump-yard",
    tabAccessKey: "Dump_Yard_Manage",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M14.0755 0H17.4615C18.8637 0 20 1.14585 20 2.55996V5.97452C20 7.38864 18.8637 8.53449 17.4615 8.53449H14.0755C12.6732 8.53449 11.537 7.38864 11.537 5.97452V2.55996C11.537 1.14585 12.6732 0 14.0755 0Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.53852 0H5.92449C7.32676 0 8.46301 1.14585 8.46301 2.55996V5.97452C8.46301 7.38864 7.32676 8.53449 5.92449 8.53449H2.53852C1.13626 8.53449 0 7.38864 0 5.97452V2.55996C0 1.14585 1.13626 0 2.53852 0ZM2.53852 11.4655H5.92449C7.32676 11.4655 8.46301 12.6114 8.46301 14.0255V17.44C8.46301 18.8532 7.32676 20 5.92449 20H2.53852C1.13626 20 0 18.8532 0 17.44V14.0255C0 12.6114 1.13626 11.4655 2.53852 11.4655ZM17.4615 11.4655H14.0755C12.6732 11.4655 11.537 12.6114 11.537 14.0255V17.44C11.537 18.8532 12.6732 20 14.0755 20H17.4615C18.8637 20 20 18.8532 20 17.44V14.0255C20 12.6114 18.8637 11.4655 17.4615 11.4655Z"
        />
      </svg>
    ),
  },
  {
    tab: "Announcements",
    activeurl: "announcements",
    url: "/announcements",
    tabAccessKey: "Announcements",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M14.0755 0H17.4615C18.8637 0 20 1.14585 20 2.55996V5.97452C20 7.38864 18.8637 8.53449 17.4615 8.53449H14.0755C12.6732 8.53449 11.537 7.38864 11.537 5.97452V2.55996C11.537 1.14585 12.6732 0 14.0755 0Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.53852 0H5.92449C7.32676 0 8.46301 1.14585 8.46301 2.55996V5.97452C8.46301 7.38864 7.32676 8.53449 5.92449 8.53449H2.53852C1.13626 8.53449 0 7.38864 0 5.97452V2.55996C0 1.14585 1.13626 0 2.53852 0ZM2.53852 11.4655H5.92449C7.32676 11.4655 8.46301 12.6114 8.46301 14.0255V17.44C8.46301 18.8532 7.32676 20 5.92449 20H2.53852C1.13626 20 0 18.8532 0 17.44V14.0255C0 12.6114 1.13626 11.4655 2.53852 11.4655ZM17.4615 11.4655H14.0755C12.6732 11.4655 11.537 12.6114 11.537 14.0255V17.44C11.537 18.8532 12.6732 20 14.0755 20H17.4615C18.8637 20 20 18.8532 20 17.44V14.0255C20 12.6114 18.8637 11.4655 17.4615 11.4655Z"
        />
      </svg>
    ),
  },
];

export const ZonalNavLinks = [
  {
    tab: "Dashboard",
    activeurl: "dashboard",
    url: "/dashboard",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M14.0755 0H17.4615C18.8637 0 20 1.14585 20 2.55996V5.97452C20 7.38864 18.8637 8.53449 17.4615 8.53449H14.0755C12.6732 8.53449 11.537 7.38864 11.537 5.97452V2.55996C11.537 1.14585 12.6732 0 14.0755 0Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.53852 0H5.92449C7.32676 0 8.46301 1.14585 8.46301 2.55996V5.97452C8.46301 7.38864 7.32676 8.53449 5.92449 8.53449H2.53852C1.13626 8.53449 0 7.38864 0 5.97452V2.55996C0 1.14585 1.13626 0 2.53852 0ZM2.53852 11.4655H5.92449C7.32676 11.4655 8.46301 12.6114 8.46301 14.0255V17.44C8.46301 18.8532 7.32676 20 5.92449 20H2.53852C1.13626 20 0 18.8532 0 17.44V14.0255C0 12.6114 1.13626 11.4655 2.53852 11.4655ZM17.4615 11.4655H14.0755C12.6732 11.4655 11.537 12.6114 11.537 14.0255V17.44C11.537 18.8532 12.6732 20 14.0755 20H17.4615C18.8637 20 20 18.8532 20 17.44V14.0255C20 12.6114 18.8637 11.4655 17.4615 11.4655Z"
        />
      </svg>
    ),
  },
  {
    tab: "Manage Contractors",
    activeurl: "manage-contractors",
    url: "/manage-contractors",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M10.0833 16.457H3.50777C2.67555 16.457 2 17.1207 2 17.9384C2 18.7549 2.67555 19.4197 3.50777 19.4197H10.0833C10.9155 19.4197 11.5911 18.7549 11.5911 17.9384C11.5911 17.1207 10.9155 16.457 10.0833 16.457Z"
        />
        <path
          opacity="0.4"
          d="M22 6.87867C22 6.06214 21.3244 5.39844 20.4933 5.39844H13.9178C13.0856 5.39844 12.41 6.06214 12.41 6.87867C12.41 7.6963 13.0856 8.36 13.9178 8.36H20.4933C21.3244 8.36 22 7.6963 22 6.87867Z"
        />
        <path d="M8.87774 6.87856C8.87774 8.74523 7.33886 10.2582 5.43887 10.2582C3.53999 10.2582 2 8.74523 2 6.87856C2 5.01298 3.53999 3.5 5.43887 3.5C7.33886 3.5 8.87774 5.01298 8.87774 6.87856Z" />
        <path d="M22 17.8992C22 19.7648 20.4611 21.2777 18.5611 21.2777C16.6622 21.2777 15.1223 19.7648 15.1223 17.8992C15.1223 16.0325 16.6622 14.5195 18.5611 14.5195C20.4611 14.5195 22 16.0325 22 17.8992Z" />
      </svg>
    ),
  },
  {
    tab: "All Track",
    activeurl: "all-track",
    url: "/all-track",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16.6286 7.0144C16.6286 4.27154 14.4 2.04297 11.6571 2.04297C8.91429 2.04297 6.85715 4.27154 6.85715 7.0144C6.85715 8.72868 11.6571 15.4144 11.6571 15.4144C11.6571 15.4144 16.6286 8.90011 16.6286 7.0144Z" />
        <path d="M11.6571 17.1278L11.1429 16.4421C10.2857 15.2421 6 9.24208 6 7.35636C6 4.27065 8.57143 1.69922 11.6571 1.69922C14.7429 1.69922 17.3143 4.27065 17.3143 7.35636C17.3143 9.4135 13.0286 15.2421 12 16.4421L11.6571 17.1278ZM11.6571 2.89922C9.25714 2.89922 7.2 4.78493 7.2 7.35636C7.2 8.38493 9.6 12.1564 11.6571 14.8992C13.7143 12.1564 16.1143 8.38493 16.1143 7.35636C16.1143 4.78493 14.0571 2.89922 11.6571 2.89922Z" />
        <path d="M21.7714 19.7002H2.39999C1.37142 19.7002 0.34285 18.8431 0.34285 17.6431C0.34285 16.4431 1.19999 15.5859 2.39999 15.5859H5.65714C5.99999 15.5859 6.34285 15.9288 6.34285 16.2717C6.34285 16.6145 6.17142 16.9574 5.82856 16.9574H2.39999C2.05714 16.9574 1.71428 17.3002 1.71428 17.6431C1.71428 17.9859 2.05714 18.3288 2.39999 18.3288H21.6C21.9429 18.3288 22.2857 18.6717 22.2857 19.0145C22.2857 19.3574 22.1143 19.7002 21.7714 19.7002Z" />
        <path d="M21.7714 22.4424H5.31428C4.97142 22.4424 4.62856 22.0996 4.62856 21.7567C4.62856 21.4138 4.97142 21.071 5.31428 21.071H21.6C21.9429 21.071 22.2857 20.7281 22.2857 20.3853C22.2857 20.0424 21.9429 19.6996 21.6 19.6996H2.39999C2.05714 19.6996 1.71428 19.3567 1.71428 19.0138C1.71428 18.671 2.05714 18.3281 2.39999 18.3281H21.6C22.6286 18.3281 23.6571 19.1853 23.6571 20.3853C23.6571 21.5853 22.8 22.4424 21.7714 22.4424Z" />
        <path d="M11.6571 9.07148C10.2857 9.07148 9.25714 8.04291 9.25714 6.67148C9.25714 5.30006 10.2857 4.27148 11.6571 4.27148C13.0286 4.27148 14.0571 5.30006 14.0571 6.67148C14.0571 8.04291 13.0286 9.07148 11.6571 9.07148ZM11.6571 5.47148C10.9714 5.47148 10.4571 5.98577 10.4571 6.67148C10.4571 7.3572 10.9714 7.87148 11.6571 7.87148C12.3429 7.87148 12.8571 7.3572 12.8571 6.67148C12.8571 5.98577 12.3429 5.47148 11.6571 5.47148Z" />
      </svg>
    ),
  },
  {
    tab: "Live Tracking",
    activeurl: "live-tracking",
    url: "/live-tracking",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3.5C12.5523 3.5 13 3.94772 13 4.5V5.57089C16.0657 6.0094 18.4906 8.43431 18.9291 11.5H20C20.5523 11.5 21 11.9477 21 12.5C21 13.0523 20.5523 13.5 20 13.5H18.9291C18.4906 16.5657 16.0657 18.9906 13 19.4291V20.5C13 21.0523 12.5523 21.5 12 21.5C11.4477 21.5 11 21.0523 11 20.5V19.4291C7.93431 18.9906 5.5094 16.5657 5.07089 13.5H4C3.44772 13.5 3 13.0523 3 12.5C3 11.9477 3.44772 11.5 4 11.5H5.07089C5.5094 8.43431 7.93431 6.0094 11 5.57089V4.5C11 3.94772 11.4477 3.5 12 3.5ZM7 12.5C7 9.73858 9.23858 7.5 12 7.5C14.7614 7.5 17 9.73858 17 12.5C17 15.2614 14.7614 17.5 12 17.5C9.23858 17.5 7 15.2614 7 12.5Z"
        />
      </svg>
    ),
  },
  {
    tab: "Grievance",
    activeurl: "grievance",
    url: "/grievance",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.0004 12.6039C22.0004 14.5818 21.4139 16.5153 20.315 18.1599C19.2162 19.8044 17.6543 21.0862 15.827 21.8431C13.9997 22.6 11.9889 22.7981 10.049 22.4122C8.10912 22.0263 6.32722 21.0739 4.92863 19.6753C3.53005 18.2767 2.5776 16.4948 2.19173 14.5549C1.80586 12.615 2.00391 10.6043 2.76081 8.77694C3.51772 6.9496 4.7995 5.38775 6.44406 4.28889C8.08862 3.19003 10.0221 2.60352 12 2.60352C13.3133 2.60352 14.6137 2.86218 15.827 3.36475C17.0403 3.86732 18.1427 4.60395 19.0714 5.53257C20 6.4612 20.7366 7.56363 21.2392 8.77694C21.7418 9.99025 22.0004 11.2907 22.0004 12.6039ZM17.9116 9.10246C17.9109 8.83756 17.8055 8.58367 17.6183 8.39624C17.4311 8.20881 17.1773 8.10304 16.9124 8.10204H7.14189C6.87699 8.10304 6.62324 8.20881 6.43604 8.39624C6.24884 8.58367 6.1434 8.83756 6.14274 9.10246V15.6545C6.14373 15.9191 6.24932 16.1727 6.43648 16.3599C6.62365 16.547 6.87721 16.6526 7.14189 16.6536H10.8429L11.7954 18.1833C11.813 18.2248 11.8425 18.2602 11.8801 18.2851C11.9177 18.31 11.9618 18.3233 12.0069 18.3233C12.0521 18.3233 12.0962 18.31 12.1338 18.2851C12.1714 18.2602 12.2009 18.2248 12.2185 18.1833L13.1722 16.6549H16.9112C17.1761 16.6539 17.4298 16.5481 17.617 16.3607C17.8042 16.1733 17.9096 15.9194 17.9103 15.6545L17.9116 9.10246ZM12.6632 14.5201C12.6632 14.6458 12.6259 14.7687 12.5561 14.8731C12.4863 14.9776 12.387 15.0591 12.2709 15.1072C12.1548 15.1552 12.0271 15.1678 11.9038 15.1433C11.7806 15.1188 11.6674 15.0583 11.5785 14.9694C11.4897 14.8806 11.4291 14.7674 11.4046 14.6441C11.3801 14.5209 11.3927 14.3931 11.4408 14.277C11.4889 14.1609 11.5703 14.0617 11.6748 13.9919C11.7793 13.922 11.9021 13.8848 12.0278 13.8848C12.1963 13.8848 12.3579 13.9517 12.4771 14.0709C12.5962 14.19 12.6632 14.3516 12.6632 14.5201ZM11.5263 12.9058V9.99173C11.5263 9.85889 11.5791 9.7315 11.673 9.63758C11.7669 9.54365 11.8943 9.49088 12.0272 9.49088C12.16 9.49088 12.2874 9.54365 12.3813 9.63758C12.4752 9.7315 12.528 9.85889 12.528 9.99173V12.9058C12.528 13.0385 12.4753 13.1657 12.3815 13.2595C12.2877 13.3533 12.1605 13.406 12.0278 13.406C11.8951 13.406 11.7679 13.3533 11.6741 13.2595C11.5803 13.1657 11.5276 13.0385 11.5276 12.9058H11.5263Z" />
      </svg>
    ),
  },
  {
    tab: "My Grievance",
    activeurl: "my-grievance",
    url: "/my-grievance",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M22.0004 12.6039C22.0004 14.5818 21.4139 16.5153 20.315 18.1599C19.2162 19.8044 17.6543 21.0862 15.827 21.8431C13.9997 22.6 11.9889 22.7981 10.049 22.4122C8.10912 22.0263 6.32722 21.0739 4.92863 19.6753C3.53005 18.2767 2.5776 16.4948 2.19173 14.5549C1.80586 12.615 2.00391 10.6043 2.76081 8.77694C3.51772 6.9496 4.7995 5.38775 6.44406 4.28889C8.08862 3.19003 10.0221 2.60352 12 2.60352C13.3133 2.60352 14.6137 2.86218 15.827 3.36475C17.0403 3.86732 18.1427 4.60395 19.0714 5.53257C20 6.4612 20.7366 7.56363 21.2392 8.77694C21.7418 9.99025 22.0004 11.2907 22.0004 12.6039ZM17.9116 9.10246C17.9109 8.83756 17.8055 8.58367 17.6183 8.39624C17.4311 8.20881 17.1773 8.10304 16.9124 8.10204H7.14189C6.87699 8.10304 6.62324 8.20881 6.43604 8.39624C6.24884 8.58367 6.1434 8.83756 6.14274 9.10246V15.6545C6.14373 15.9191 6.24932 16.1727 6.43648 16.3599C6.62365 16.547 6.87721 16.6526 7.14189 16.6536H10.8429L11.7954 18.1833C11.813 18.2248 11.8425 18.2602 11.8801 18.2851C11.9177 18.31 11.9618 18.3233 12.0069 18.3233C12.0521 18.3233 12.0962 18.31 12.1338 18.2851C12.1714 18.2602 12.2009 18.2248 12.2185 18.1833L13.1722 16.6549H16.9112C17.1761 16.6539 17.4298 16.5481 17.617 16.3607C17.8042 16.1733 17.9096 15.9194 17.9103 15.6545L17.9116 9.10246ZM12.6632 14.5201C12.6632 14.6458 12.6259 14.7687 12.5561 14.8731C12.4863 14.9776 12.387 15.0591 12.2709 15.1072C12.1548 15.1552 12.0271 15.1678 11.9038 15.1433C11.7806 15.1188 11.6674 15.0583 11.5785 14.9694C11.4897 14.8806 11.4291 14.7674 11.4046 14.6441C11.3801 14.5209 11.3927 14.3931 11.4408 14.277C11.4889 14.1609 11.5703 14.0617 11.6748 13.9919C11.7793 13.922 11.9021 13.8848 12.0278 13.8848C12.1963 13.8848 12.3579 13.9517 12.4771 14.0709C12.5962 14.19 12.6632 14.3516 12.6632 14.5201ZM11.5263 12.9058V9.99173C11.5263 9.85889 11.5791 9.7315 11.673 9.63758C11.7669 9.54365 11.8943 9.49088 12.0272 9.49088C12.16 9.49088 12.2874 9.54365 12.3813 9.63758C12.4752 9.7315 12.528 9.85889 12.528 9.99173V12.9058C12.528 13.0385 12.4753 13.1657 12.3815 13.2595C12.2877 13.3533 12.1605 13.406 12.0278 13.406C11.8951 13.406 11.7679 13.3533 11.6741 13.2595C11.5803 13.1657 11.5276 13.0385 11.5276 12.9058H11.5263Z" />
      </svg>
    ),
  },
  {
    tab: "Transfer Request",
    activeurl: "transfer-request",
    url: "/transfer-request",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.25 4.00003C10.25 3.69074 10.0602 3.41317 9.77191 3.30105C9.48366 3.18892 9.15614 3.26524 8.94715 3.49324L3.44715 9.49324C3.24617 9.71248 3.19374 10.0298 3.3135 10.302C3.43327 10.5743 3.70259 10.75 4.00002 10.75H20C20.4142 10.75 20.75 10.4142 20.75 10C20.75 9.58582 20.4142 9.25003 20 9.25003L10.25 9.25003V4.00003Z"></path>{" "}
        <path
          opacity="0.7"
          d="M13.75 20L13.75 14.75H4C3.58579 14.75 3.25 14.4142 3.25 14C3.25 13.5858 3.58579 13.25 4 13.25L20 13.25C20.2974 13.25 20.5667 13.4258 20.6865 13.698C20.8063 13.9703 20.7538 14.2875 20.5529 14.5068L15.0529 20.5068C14.8439 20.7348 14.5164 20.8111 14.2281 20.699C13.9399 20.5869 13.75 20.3093 13.75 20Z"
        ></path>{" "}
      </svg>
    ),
  },
  {
    tab: "Survey Detail",
    activeurl: "survey-detail",
    url: "/survey-detail",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1340_1445)">
          <path d="M21.0886 4.6228C20.9121 4.20533 20.6184 3.85227 20.2486 3.60181C19.8787 3.35206 19.4282 3.20483 18.9492 3.20483H16.9497V2.85988H14.0515C14.0647 2.76613 14.0721 2.66942 14.0721 2.57202C14.072 1.42944 13.1426 0.5 12 0.5C10.8574 0.5 9.92799 1.42944 9.92799 2.57202C9.92799 2.66942 9.9353 2.76613 9.94852 2.85988H7.05033V3.20483H5.05079C4.73143 3.20483 4.42458 3.27003 4.14699 3.38792C3.72952 3.56445 3.37576 3.85812 3.12526 4.22802C2.87551 4.59861 2.72827 5.04833 2.72827 5.52734V22.1782C2.72827 22.4961 2.79347 22.8037 2.91137 23.082C3.0879 23.4995 3.38157 23.8526 3.75146 24.103C4.12205 24.3535 4.57177 24.5 5.05079 24.5H18.9492C19.2678 24.5 19.5754 24.4355 19.853 24.3169C20.2712 24.1411 20.6243 23.8467 20.8748 23.4768C21.1245 23.1069 21.2717 22.6565 21.2717 22.1782V5.52734C21.2717 5.20803 21.2073 4.90114 21.0886 4.6228ZM12 1.80298C12.4241 1.80298 12.769 2.14794 12.769 2.57202C12.769 2.67383 12.7485 2.77048 12.7126 2.85988H11.2881C11.2515 2.77053 11.2309 2.67383 11.2309 2.57202C11.231 2.14794 11.5767 1.80298 12 1.80298ZM19.8904 22.1782C19.8904 22.3101 19.864 22.4316 19.8164 22.5437C19.7461 22.7114 19.626 22.8565 19.4751 22.959C19.3242 23.06 19.147 23.1186 18.9492 23.1186H5.05079C4.91893 23.1186 4.79663 23.0922 4.68455 23.0454C4.51608 22.9743 4.3718 22.8535 4.26999 22.7033C4.16893 22.5524 4.11033 22.3752 4.10958 22.1782V5.52734C4.10958 5.39548 4.13597 5.27319 4.18355 5.16111C4.25462 4.99264 4.37471 4.84761 4.52485 4.74655C4.67574 4.64548 4.85297 4.58689 5.05074 4.58614H7.05024V4.874C7.05024 5.41452 7.48824 5.85252 8.02951 5.85252H15.9712C16.5117 5.85252 16.9497 5.41452 16.9497 4.874V4.58614H18.9492C19.081 4.58614 19.2033 4.61253 19.3154 4.66011C19.4831 4.73042 19.6282 4.85056 19.73 5.00141C19.8318 5.15225 19.8904 5.32953 19.8904 5.5273V22.1782Z" />
          <path d="M8.80154 8.5H7.31912V9.98242H8.80154V8.5Z" />
          <path d="M16.6817 8.5H10.5711V9.98242H16.6817V8.5Z" />
          <path d="M8.80154 12.8809H7.31912V14.3633H8.80154V12.8809Z" />
          <path d="M16.6817 12.8809H10.5711V14.3633H16.6817V12.8809Z" />
          <path d="M8.80154 17.2617H7.31912V18.7441H8.80154V17.2617Z" />
          <path d="M16.6817 17.2617H10.5711V18.7441H16.6817V17.2617Z" />
        </g>
        <defs>
          <clipPath id="clip0_1340_1445">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    tab: "Garbage Info",
    activeurl: "garbage-info",
    url: "/garbage-info",
    icon: (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1340_1462)">
          <path d="M12.1629 8.72764H8.86697V7.2628H5.20491V8.72764H1.90903V10.925H2.6415V19.3566H11.4306V10.925H12.163L12.1629 8.72764ZM5.93728 7.99517H8.13459V8.72764H5.93728V7.99517ZM4.47244 17.8917V10.9249H5.20491V17.8917H4.47244ZM6.66975 17.8917V10.9249H7.40222V17.8917H6.66975ZM9.59944 17.8917H8.86697V10.9249H9.59944V17.8917ZM18.6195 9.2398C18.4549 9.06842 18.4603 8.79598 18.6317 8.63127C18.8031 8.46655 19.0755 8.47208 19.2402 8.64345C19.4049 8.81483 19.3994 9.08727 19.228 9.25198C19.0567 9.4167 18.7841 9.41117 18.6195 9.2398ZM21.4934 8.43505C21.6648 8.27042 21.6703 7.99798 21.5056 7.82652C21.3409 7.65505 21.0685 7.64961 20.8971 7.81433C20.7257 7.97895 20.7202 8.25139 20.8849 8.42286C21.0496 8.59433 21.3219 8.59977 21.4934 8.43505ZM16.114 6.01048C16.2854 5.84586 16.2909 5.57342 16.1262 5.40195C15.9616 5.23058 15.6892 5.22505 15.5177 5.38977C15.3462 5.55448 15.3408 5.82683 15.5055 5.9983C15.6702 6.16976 15.9427 6.1752 16.114 6.01048ZM22.4151 6.32295C22.5864 6.15833 22.592 5.88589 22.4273 5.71442C22.2625 5.54295 21.9902 5.53752 21.8187 5.70223C21.6473 5.86695 21.6418 6.1393 21.8065 6.31077C21.9713 6.48214 22.2437 6.48758 22.4151 6.32295ZM19.1507 2.99389C19.3221 2.82927 19.3276 2.55683 19.1629 2.38536C18.9983 2.21398 18.7258 2.20845 18.5543 2.37317C18.3829 2.53789 18.3774 2.81023 18.5422 2.9817C18.7069 3.15308 18.9792 3.15852 19.1507 2.99389ZM21.5491 3.97208C21.7205 3.80745 21.726 3.53502 21.5613 3.36355C21.3967 3.19217 21.1242 3.18664 20.9528 3.35136C20.7813 3.51608 20.7758 3.78842 20.9406 3.95989C21.1053 4.13127 21.3777 4.1367 21.5491 3.97208ZM17.1034 3.8998C17.2748 3.73517 17.2803 3.46273 17.1156 3.29127C16.9509 3.11989 16.6785 3.11436 16.507 3.27908C16.3356 3.4438 16.3301 3.71614 16.4948 3.88761C16.6596 4.05908 16.9319 4.06442 17.1034 3.8998ZM17.8293 6.48458L16.2948 7.9587L16.1467 8.59827L16.7917 8.47592L18.3262 7.0018C18.7609 7.24723 19.337 7.19117 19.7335 6.81017C20.2163 6.34639 20.2313 5.60267 19.7675 5.11986C19.3037 4.63705 18.56 4.62214 18.0772 5.08592C17.6806 5.46701 17.585 6.02314 17.8293 6.48458ZM23.8095 5.81783C23.8095 7.84958 22.5719 9.60045 20.8125 10.3569V11.8441H19.3845V20.1669C19.3845 21.7688 18.0934 23.0599 16.4915 23.0599H14.0427V24.1081H0.1875V20.8441H14.0625V22.1082L16.5633 22.1035C17.6392 22.1035 18.4999 21.2428 18.4999 20.1669V11.8441H17.0625V10.3615C15.2974 9.60767 14.0547 7.8537 14.0547 5.81783C14.0547 3.09223 16.2544 0.892578 18.98 0.892578C21.6817 0.892578 23.9052 3.09214 23.8095 5.81783ZM22.6638 3.88489C21.5974 1.85239 19.0795 1.06752 17.047 2.13392C15.0145 3.20033 14.2297 5.71817 15.2961 7.75067C16.3625 9.78317 18.8803 10.568 20.9128 9.50164C22.9453 8.43523 23.7302 5.91739 22.6638 3.88489Z" />
        </g>
        <defs>
          <clipPath id="clip0_1340_1462">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];
